export const sourceMapped = (arr = []) => {
    return [...[{ code: "", name: "-" }], ...arr].map((item) => {
        return { title: item.name, value: item.code }
    });
};